
  <div class="card-display-list" [ngClass]="{'has-active-card':active >= 0, 'active-list': isActiveList}">
    <!-- <div class="card-display-item" [ngClass]="{'active-card':active == $i}"> -->
    <div class="card-display-item">
      <div>
       <!--NEBULAR TODO on update <mat-tag-list style="position: absolute;left: 6%;top: 19px;">
          <mat-tag *ngIf="view.length > 0" appearance="filled" status="info" [text]="view.length"></mat-tag>
        </mat-tag-list>-->
        <i [ngClass]="item.icon" [title]="item.card_label||'Card'" *ngIf="indexActive === false"></i>
        <div class="card-display-item-title" *ngIf="info.active_card !== false">{{item.card_label||'card'| translation}}</div>

      </div>
    </div>

  </div>

